import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/img/logo-white.svg'


const _hoisted_1 = { class: "flex-container-col banner-area" }
const _hoisted_2 = {
  id: "topBanner",
  class: "flex-container-row flex-item gap20",
  style: {"white-space":"nowrap"}
}
const _hoisted_3 = { class: "flex-container-row align-center gap20 title-adjust" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  id: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "back-button hideOnSmallResolution"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-arrow-left" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "text-cutoff"
}
const _hoisted_10 = {
  key: 2,
  class: "title-stack"
}
const _hoisted_11 = { class: "site-title text-cutoff" }
const _hoisted_12 = { class: "title-text text-cutoff" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_portal_notification = _resolveComponent("portal-notification")!
  const _component_site_title = _resolveComponent("site-title")!
  const _component_top_banner_toolbar = _resolveComponent("top-banner-toolbar")!
  const _component_navigation_bar = _resolveComponent("navigation-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_portal_notification),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.showBackButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"])),
                title: _ctx.localize('Back')
              }, _hoisted_8, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        (_ctx.title == null)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_9, [
              _createVNode(_component_site_title)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_site_title)
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.title), 1)
            ]))
      ]),
      (!_ctx.isSmallScreen)
        ? (_openBlock(), _createBlock(_component_top_banner_toolbar, {
            key: 0,
            "show-log-off": _ctx.showLogOff
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["show-log-off"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_navigation_bar, {
      items: _ctx.effectiveNavigationItems,
      "render-navigation-template": _ctx.renderCustomNavigationSlot
    }, {
      navigation: _withCtx(() => [
        _renderSlot(_ctx.$slots, "navigation")
      ]),
      _: 3
    }, 8, ["items", "render-navigation-template"])
  ]))
}